import React from "react";
import { Box, Input, Button } from "@chakra-ui/react";
import { IoIosSearch } from "react-icons/io";
import { MdMyLocation } from "react-icons/md";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';

interface SearchLocationProps {
  colors: {
    buttonBg: string;
    buttonText: string;
  };
  setSearchQuery: (query: string) => void;
  handleUseCurrentLocation: () => void;
  setLat: (lat: number) => void;          
  setLong: (lng: number) => void;          
}

const SearchLocation: React.FC<SearchLocationProps> = ({
  colors,
  setSearchQuery,
  handleUseCurrentLocation,
  setLat,           
  setLong 
}) => {

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: { country: 'au' },
      types: ['(regions)'],
    },
  });

  return (
    <Box display="flex"
      flexDirection={{ base: "column", md: "row" }} width={"100%"} gap={4}>
      <Box position="relative" width="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flex="1"
          p="1"
          rounded="full"
          borderWidth="1px"
        >
          <Input
            variant="unstyled"
            ml="4"
            color="#000"
            _placeholder={{ color: "gray.500" }}
            width="100%"
            value={value}
            onChange={(e) => setValue(e.target.value, true)}

            placeholder="Search suburb, state, or postcode"
            disabled={!ready}
          />
          <Button
            size="sm"
            rounded="full"
            bg={colors.buttonBg}
            color={colors.buttonText}
            p="2"
            _hover={{ bg: colors.buttonBg, opacity: 0.9 }}
          >
            <IoIosSearch />
          </Button>
        </Box>
        {status === 'OK' && (
          <Box
            position="absolute"
            top="100%"
            left={0}
            right={0}
            bg="white"
            zIndex={10}
            boxShadow="md"
            borderRadius="md"
            mt={1}
            maxHeight="200px"
            overflowY="auto"
          >
            {data.map(({ place_id, description }) => (
              <Box
                key={place_id}
                px={4}
                py={2}
                _hover={{ backgroundColor: 'gray.100', cursor: 'pointer' }}
                onClick={async () => {
                  setValue(description, false);
                  clearSuggestions();
                  const results = await getGeocode({ address: description });
                  const { lat, lng } = await getLatLng(results[0]);
                  setLat(lat);
                  setLong(lng);
                  // console.log(lat, lng);
                }}

              >
                {description}
              </Box>
            ))}
          </Box>
        )}
      </Box>
      <Button
        rounded="full"
        bg={colors.buttonBg}
        color={colors.buttonText}
        p="2"
        leftIcon={<MdMyLocation />}
        minW={'200px'}
        onClick={handleUseCurrentLocation}
      >
        Use current location
      </Button>
    </Box>
  );
};

export default SearchLocation;